
export default {
  name: "LoadingScreen",
  setup() {
    return {};
  },
};
